const state = () => ({
  dark: {
    type: 'dark-pickled-bluewood',
    variant: null
  },
  light: {
    type: 'light',
    variant: 'bg-white'
  }
});

export const sidebarConfig = {
  namespaced: true,
  state
};
